import { AssetType } from "@zapier/canvas-state";
import { editInterfaceUrl } from "./editInterfaceUrl";
import { buildEditorLink } from "./buildEditorLink";
import { getTablesOrigin } from "./urls";

type Props = {
  assetType: AssetType;
  assetId: string | null;
  interfaceProjectId: string | undefined;
  isZapPublished: boolean | null;
};

export function getAssetLink({
  assetType,
  assetId,
  interfaceProjectId,
  isZapPublished,
}: Props) {
  if (assetType === "zap" && assetId) {
    return buildEditorLink(assetId, Boolean(isZapPublished));
  }

  if (assetType === "table" && assetId) {
    return `//${getTablesOrigin()}/app/tables/t/${assetId}`;
  }

  if (assetType === "chatbot" && assetId) {
    return `/app/chatbots/${assetId}`;
  }

  if (assetType === "interface" && (interfaceProjectId || assetId)) {
    return editInterfaceUrl(interfaceProjectId!, assetId);
  }
}
